import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import NestedList from 'components/NestedList/NestedList.jsx';
import WheelForm from 'components/Forms/WheelsForm.jsx';
import { apiKey, refreshToken, APIRoot } from 'variables/authentication.jsx';
import red from '@material-ui/core/colors/red';

import Api from 'services/api';

import Tooltip from '@material-ui/core/Tooltip';

const CameraWheelElementsAPIRoot = APIRoot + "/client-versions";
// const GamesAPIRoot = APIRoot + "/games";



const modes = {
  EDIT: 'edit',
  NEW: 'new',
  VIEW: 'view'
}


function getMuiTheme() {
  return createMuiTheme({
    overrides: {
      MUIDataTableHeadCell: {

      },
      MUIDataTableBodyCell: {

      }
    },
    palette: {
      secondary: red
    },
  })
}


class WheelsTable extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      tableData: [],
      rawData: [],
      mode: modes.VIEW,
      selected_data: {
        "client_games": []
      }
    };

    this.ReloadData = this.ReloadData.bind(this);
    this.customSort = this.customSort.bind(this);
    this.switchMode = this.switchMode.bind(this);
    this.getMode = this.getMode.bind(this);
    this.ReloadData();

    this.options = {
      selectableRows: false,
      customSort: this.customSort,
      print: false,
      customToolbar: () =>
        <Tooltip title={"Add a new Version"}>
          <IconButton onClick={this.startAdd}>
            <AddIcon />
          </IconButton>
        </Tooltip>
    };

    this.state.columns = [
      {
        name: "Platform",
        options: {
          customSort: this.customSort
        }
      },
      {
        name: "Version",
        options: {
        }
      },
      {
        name: 'Games',
        options: {
          customBodyRender: (value, tableMeta, updateValue) => {
            //console.log(this.state.rawData)
            //console.log(this.state.rawData[tableMeta.rowIndex])
            return (
              <NestedList value={value} tableMeta={this.state.rawData[tableMeta.rowIndex]} />
            );
          },
          filter: false,
          sort: false,
        }
      },
      {
        name: "Action",
        options: {
          customBodyRender: (value, tableMeta, updateValue) => {
            return (

              <IconButton onClick={this.startEdit(tableMeta.rowIndex)}>
                <EditIcon />
              </IconButton>


            );
          },

          filter: false,
          sort: false
        }
      }
    ];
  }


  switchMode(target_mode, reload = false) {
    this.setState({ mode: target_mode });
    if (reload == true)
      this.ReloadData();
  }

  getMode() {
    return this.state.mode;
  }

  startEdit = rowNum => _ => {

    this.setState({ selected_data: this.state.rawData[rowNum] });
    this.switchMode(modes.EDIT);
  }

  startAdd = _ => {
    this.switchMode(modes.NEW);
  }

  customSort(data, colIndex, order) {

    if (!this.state.rawData) {
      this.setState({ rawData: [] })
      return [];
    }
    if (colIndex >= 2) return data;
    console.log(this.state.rawData);
    var sort_result = this.state.rawData.sort((a, b) => {
      if (colIndex == 1) {
        var ret = order == 'desc' ? -1 : 1;
        if (a.version_major < b.version_major) return ret;
        if (a.version_major > b.version_major) return -ret;
        if (a.version_minor < b.version_minor) return ret;
        if (a.version_minor > b.version_minor) return -ret;
        if (a.version_patch < b.version_patch) return ret;
        if (a.version_patch > b.version_patch) return -ret;
      }
      return a.device_type < b.device_type ? -1 : 1;
    })

    this.setState({ rawData: sort_result });
    // only sort on first two columns

    return data.sort((a, b) => {
      if (colIndex == 1) {
        return order == 'desc' ? a.data[colIndex].localeCompare(b.data[colIndex], undefined, { numeric: true })
          : b.data[colIndex].localeCompare(a.data[colIndex], undefined, { numeric: true });
      }
      if (order == 'desc') {
        return a.data[colIndex] < b.data[colIndex] ? -1 : 1;
      }
      return a.data[colIndex] > b.data[colIndex] ? -1 : 1;
    })
  }


  async ReloadData(secondChance = true) {
    try {

      const responseData = await Api({
        endpoint: "/client-versions",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        }
      })

      if (!responseData || responseData == true) return;
      this.setState({ rawData: responseData })

      const tableData = responseData.map((item) => {
        var games = item.client_games.map((game) => {
          return game.game.unity_command;
        })
        var game_string = `${games.length} ${games.length == 1 ? 'game' : 'games'}`;

        return [item.device_type.toUpperCase(),
        item.version_major + "." + item.version_minor + "." + item.version_patch,
          game_string
        ];
      });

      this.setState({ tableData });
    } catch (e) {
      console.error(e)
    }

  }

  render() {

    if (this.state.mode == modes.VIEW) {
      return (
        <MuiThemeProvider theme={getMuiTheme()}>
          <MUIDataTable
            title="Camera Wheel Elements"
            columns={this.state.columns}
            data={this.state.tableData}
            options={this.options}
          />
        </MuiThemeProvider>
      );
    }
    return (
      <MuiThemeProvider theme={getMuiTheme()}>
        <WheelForm switchMode={this.switchMode}
          getMode={this.getMode}
          row_data={this.state.selected_data}>
        </WheelForm>
      </MuiThemeProvider>
    )

  }

}

export default WheelsTable;
